const SERVER_URL = "/api";
export function getParameters() {
    return (fetch(SERVER_URL+"/parameters"))
}

export function getScenrios() {
    return (fetch(SERVER_URL+"/scenarios"))
}

export function getHeatmap(scenario: string, parameter: string, time: string) {
    return fetch(SERVER_URL+`/heatmap?scenario=${scenario}&parameter=${parameter}&time=${time}`)
}

export function getHeatMapDiff(scenario: string, baseScenario: string, parameter: string, time: string) {
    return fetch(SERVER_URL+`/heatmap_diff?scenario=${scenario}&baseScenario=${baseScenario}&parameter=${parameter}&time=${time}`)
}

export function getTimeSeries(scenario: string, parameter: string, lat: number, lon: number) {
    return fetch(SERVER_URL+`/timeseries?scenario=${scenario}&parameter=${parameter}&lat=${lat}&lon=${lon}`)
}
export function getTimeSeriesDownsampled(scenario: string, parameter: string, lat: number, lon: number, maxPoints: number) {
    return fetch(SERVER_URL+`/timeseries?scenario=${scenario}&parameter=${parameter}&lat=${lat}&lon=${lon}&maxPoints=${maxPoints}`)
}

export function getFrequencyCurve(scenario: string, parameter: string, lat: number, lon: number) {
    return fetch(SERVER_URL+`/frequency?scenario=${scenario}&parameter=${parameter}&lat=${lat}&lon=${lon}`)
}

export function getSpatialNames() {
    return fetch(SERVER_URL+`/get_spatial_names`)
}


export function getGeoJsonFile(name: string) {
    return fetch(SERVER_URL+`/geojson/${name}`)
}

export function getGeoJsonValues(scenario: string, parameter: string, spatialname: string, time: string) {
    return fetch(SERVER_URL+`/heatmap_avg?scenario=${scenario}&parameter=${parameter}&spatial=${spatialname}&time=${time}`)
}

export function getGeoJsonTimeSeries(scenario: string, parameter: string, group: string, id: string) {
    let url = SERVER_URL+`/timeseries_avg?scenario=${encodeURIComponent(scenario)}&parameter=${encodeURIComponent(parameter)}&group=${encodeURIComponent(group)}&id=${encodeURIComponent(id)}`;
    let response = fetch(url, { method: 'GET',});
    return response;
}

export function getGeoJsonFrequency(scenario: string, parameter: string, group: string, id: string) {
    let url = SERVER_URL+`/frequency_avg?scenario=${encodeURIComponent(scenario)}&parameter=${encodeURIComponent(parameter)}&group=${encodeURIComponent(group)}&id=${encodeURIComponent(id)}`;
    let response = fetch(url, { method: 'GET',});
    return response;
}



export function getGeoJsonTimeSeriesDownsampled(scenario: string, parameter: string, spatialname: string, objectId: string, maxPoints: number) {
    return fetch(SERVER_URL+`/timeseries_avg?scenario=${scenario}&parameter=${parameter}&group=${spatialname}&id=${objectId}&maxPoints=${maxPoints}`)
}

export function getTimeWindow() {
    return fetch(SERVER_URL+"/timewindow")
}




export function getColorScale(parameter: string) {
    return fetch(SERVER_URL+`/contours?parameter=${parameter}`);
}


export function exportTimeSeriesByPolygon(
  selectedScenario: string,
  selectedParameter: string,
  featureTypeName: string,
  featureId: string
) {
    const params = new URLSearchParams();
    params.append("scenario", selectedScenario);
    params.append("parameter", selectedParameter);
    params.append("group",featureTypeName);
    params.append("id", featureId);

    // Construct the URL with query parameters
    return fetch(`/api/timeseries_export?${params.toString()}`, {method: "GET",});
}

